import {Injectable, OnInit} from "@angular/core";

import {StaticsService} from "../sys/statics.service";
import {AfsForm} from "../model/afsForm";
import { Parser } from '@json2csv/plainjs';
import {CacheService} from "../sys/cache.service";
import {SettingsService} from "../sys/settings.service";


declare var $: any;

@Injectable()
export class CsvManagerService {

    constructor(private staticsService: StaticsService,
                private cacheService: CacheService,
                private settingsService: SettingsService) {

    }

    private stateCoutryCodeTransform(item): string{
        if(item.fields.state){
            return item.fields.state;
        }
        else if(item.fields.countrycode){
            return item.fields.countrycode;
        }
        else{
            return "";
        }
    }

    
    private  planTypeTransform(item,planTypeDisplays): string{
        if(item != undefined){
            let str = planTypeDisplays.get(item);
            if (str != undefined) {
               str =  str.trim().replace(":", "");
            }
            else {
                str = "";
            }
            return str;
        }

    }

    public generate(csvForm: AfsForm) {
        this.staticsService.getFilterType().EMPLOYER.toString()

        const servicePdfPath = this.settingsService.getServicePdfPath();

        const planTypeDisplays = new Map();
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_SINGLE.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl3'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_MULTIPLE.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl2'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_MULTI.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl1'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_DFE_MASTER.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl5'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_DFE_UNABLE.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl6'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_DFE_GROUP.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl7'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_DFE_103.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl8'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_DFE_COM.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl9'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_DFE_POOLED.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl10'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_DFE_ALL.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl4'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_DFE_DCG.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl11'));
        planTypeDisplays.set(this.staticsService.getEmployerFilter().EMPLOYER_NO_ENTRY.toString(),this.cacheService.getLabelFromResource('FILTER:FILTEREmployerLbl12'));


        const planTypeTransformFunc = this.planTypeTransform;
        const stateCoutryCodeTransformFunc = this.stateCoutryCodeTransform;

        const fields = [
            {
                label: 'Ack ID',
                value: 'fields.ackid'
            },
            {
                label: 'EIN',
                value: function(row){
                    return row.fields.ein;
                }
               
            }, {
                label: 'PN',
                value: function(row){
                    return row.fields.pn;
                }
              
            }, {
                label: 'Plan Name',
                value: 'fields.planname'
            }, {
                label: 'Sponsor Name',
                value: 'fields.plansponsor'
            }, {
                label: 'Address',
                value: 'fields.address'
            }, {
                label: 'City',
                value: 'fields.city'
            }, {
                label: 'State',
                value:function(row){
                    return stateCoutryCodeTransformFunc(row);
                }
            }, {
                label: 'Zip',
                value: function(row){
                    return row.fields.zip;
                }
            }, {
                label: 'Date Received',
                value: function (row) {
                    if (row.fields.datereceived){ return row.fields.datereceived.split('T')[0]}
                }
            }, {
                label: 'Plan Codes',
                value: function (row) {
                    if (row.fields.plancode) {
                        return row.fields.plancode.join()
                    }
                }
            }, {
                label: 'Plan Type',
                value: function (row) {
                    return planTypeTransformFunc(row.fields.plantype,planTypeDisplays);   
                }

            }, {
                label: 'Plan Year',
                value: 'fields.planyear'
            }, {
                label: 'Participants',
                value: function (row) {
                    if (row.fields.participantsboy){ 
                        return Number(row.fields.participantsboy).toString()
                    }
                }
            }, {
                label: 'Participants EOY',
                value: function (row) {
                    if (row.fields.participantseoy){ 
                        return Number(row.fields.participantseoy).toString()
                    }
                }
            }, {
                label: 'Assets BOY',
                value: function (row) {
                    if (row.fields.assetsboy){ 
                        return Number(row.fields.assetsboy).toString();
                    }
                }
            }, {
                label: 'Assets',
                value: function (row) {
                    if (row.fields.assetseoy){
                       return Number(row.fields.assetseoy).toString();
                    }
                }
            }, {
                label: 'Link',
                value: function (row) {
                    if (row.fields.pdfpath) {
                        return servicePdfPath + row.fields.pdfpath
                    }
                }
            }
        ]


        const json2csvParser = new Parser({fields});
        const csv = json2csvParser.parse(csvForm.hits.hit);

        if (this.downloadCSV(csv)){
            console.log("csv download success");
        }
        else{
            console.log("csv download fail");
        }

    }

    private downloadCSV(csv): boolean {

        let blob = new Blob([csv], {type: 'text/csv;charset-utf-8;'});


        const exportedFileName = 'export5500.csv';

        let link = document.createElement("a");
        if (link.download !== undefined) { //feature detection
            //Browsers that support HTML5 download attribute
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        return true;
    }

}

